export default "__VITE_ASSET__e7224541__"